import { useEffect, useState } from "react";
import { getAll } from "../api/API";
import { toast } from "react-toastify";

export const useCohorts = () => {
  const [cohorts, setCohorts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCohorts = async () => {
      try {
        const res = await getAll("/cohorts", { limit: 50 });

        const sorted = (res.docs || []).sort((a, b) => {
          // Aspiring always first
          if (a.title === "Aspiring") return -1;
          if (b.title === "Aspiring") return 1;

          const getStartYear = (range) => {
            if (!range) return Infinity;
            const match = range.match(/^(-?\d+)/);
            return match ? parseInt(match[1], 10) : Infinity;
          };

          return getStartYear(a.range) - getStartYear(b.range);
        });

        setCohorts(sorted);
      } catch (err) {
        console.error("Failed to load cohorts:", err);
        toast.error("Failed to load cohorts. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCohorts();
  }, []);

  return { cohorts, loading };
};
